import React from 'react'
import Side from './Hero Section/Side'
import Contact from './contact/Contact'
import Header from './Hero Section/Header'
import Footer from './footer/Footer'
import '../styles/contact/Contact.css'
import { useTranslation } from 'react-i18next'
import DarkModeSide from './DarkModeSide'

export default function ContactUs() {
  const {t} = useTranslation();
  return (
    <>
        <Side/>
        <DarkModeSide/>
        <Header/>
        <section className="Contact-container-router">
        <h1>
          <span className="SpanHighlightWhite">{t("contactInfo.contact")}</span>
        </h1>
      </section>
        <Contact/>
        <Footer/>
    </>
  )
}
